module.exports = __webpack_public_path__ + "img/dennis.aad0eff8.jpg";